<template>
  <div class="order-box">
    <div class="order-content">
      <div class="list">
        <ul>
          <li>
            <p :class="{'order-title': item.orderInfo.orderStatus == 2}" :title="item.orderInfo.orderName">
              <b>订单编号：{{item.orderInfo.orderNo}}</b>
              <span :class="{success: item.statue == 5}">状态：<i>{{item.orderInfo.deliveryStatus | statue}}</i></span>
            </p>
            <div class="Order">
              <p><b>订单名称：{{item.orderInfo.orderName}}</b><span>缴费金额：<i>{{item.orderInfo.amount}}</i></span></p>
              <p><b>手机号码：{{item.orderInfo.deliveryMobile |
                  markedPhone}}</b><span>收货人：<i>{{item.orderInfo.deliveryContact}}</i></span></p>
              <p style="height: 1.22rem;">地址：{{item.orderInfo.deliveryDetailedAddress}}</p>
              <p>快递名称：<i>{{item.orderInfo.expressName}}</i></p>
              <p>缴费时间：{{item.orderInfo.payTime}}</p>
              <p>快递单号：{{item.orderInfo.expressNo}}</p>
            </div>
          </li>
        </ul>

      </div>

    </div>
  </div>
</template>

<script>
  import { getPZUrl, paymentCancel, cancelMeetingOrder } from "@/api/dictionary";
  import { Uploader, Toast, Button, ImagePreview, Dialog } from "vant";
  import { setSessionStore } from "@/utils/sessionStorage.js"


  export default {
    data() {
      return {
        PZUrl: ""
      };
    },
    props: {
      item: {
        type: Object,
        default: () => { }
      },
      from: {
        type: String,
        default: ""
      },
      isWXPay: {
        type: Boolean,
        default: true
      }
    },
    filters: {
      markedPhone(val) {
        return val ? val.substr(0, 3) + "****" + val.substr(7, 4) : val;
      },
      statue(val) {
        switch (val) {
          case 1:
            return "未邮寄";
            bredk;
          case 2:
            return "已邮寄";
            bredk;
          case 3:
            return "已收件";
            bredk;
          default:
            return "未邮寄";
            bredk;
        }
      }
    },
    components: {
      [Uploader.name]: Uploader,
      [Toast.name]: Toast,
      [Button.name]: Button,
      [ImagePreview.name]: ImagePreview,
      [Dialog.name]: Dialog,
    },
    methods: {
      go(pathName) {
        console.log(this.item);
        let params = {};
        params.orderId = this.item.orderInfo.id;
        this.$router.push({ name: pathName, query: params });
      },
      show() {
        const viewer = this.$el.querySelector(".images").$viewer;
        viewer.show();
      },
      onLine() {
        this.$emit("onLine", this.item.orderInfo);
      },
      underLine() {
        this.$router.push({
          name: "payUndeLine",
          params: { id: this.item.orderInfo.id },
          query: { form: this.from }
        });
      },
      cancel() {
        let params = {
          orderId: this.item.orderInfo.id
        };
        Dialog.confirm("确认删除订单?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          // on confirm
          if (this.from == "meetingUndeLine") {
            this.meetingCancel(params);
          } else {
            this.paymentCancel(params);
          }
        }).catch(() => {
          // on cancel
        });
      },
      paymentCancel(params) {
        paymentCancel(params).then(res => {
          Toast.success("取消成功！");
          this.$emit("getDate", this.item);
        });
      },
      meetingCancel(params) {
        cancelMeetingOrder(params).then(res => {
          if (res.success) {
            this.$emit("getDate", this.item);
          } else {
            Toast.fail("创建订单失败");
          }
        });
      },
      deleteOrder() {
        let params = {
          meetingId: this.item.meeting.id,
          memberId: sessionStorage.getItem("memberId")
        };

        this.$confirm("确认删除订单?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            deleteMeetingOrder(params).then(res => {
              if (res.success) {
                this.$emit("update");
              } else {
                Toast.fail("创建订单失败");
              }
            });
          })
          .catch(() => { });
      },
      //获取凭证
      getDisplay(offlineVoucher) {
        let params = {
          id: offlineVoucher
        };

        if (!offlineVoucher) return;

        getPZUrl(params).then(res => {
          if (res.success) {
            this.PZUrl = res.result;
          }
        });
      }
    },
    mounted() {
      this.getDisplay(this.item.orderInfo.offlineVoucher);
    }
  };
</script>

<style scoped lang="less">
  .content ul li {
    border-bottom: #f2f2f2 solid 8px;
    padding: 20px 0 15px 0;

    p {
      padding: 0 20px;
      height: 36px;

      b {
        float: left;
        display: block;
        width: 67%;
        line-height: 28px;
      }

      span {
        display: block;
        float: right;
        font-size: 14px;
        line-height: 28px;

        i {
          color: #ea4848;
        }
      }
    }
  }

  .Order {
    background: #fafafa;
    padding: 15px 0;
    margin-top: 15px;
  }

  .Order p {
    line-height: 32px;
    color: #848484;
    font-size: 14px;
  }

  .fontsBox {
    width: 84%;
    margin: 20px auto 0 auto;
    background: #fff6ec;
    padding: 14px;
    font-size: 13px;
    border: #f6d0a2 dashed 1px;
    line-height: 22px;
    color: #ffbe4e;
  }

  .imgBox {
    padding: 20px;

    img {
      width: 100%;
    }
  }

  /deep/.van-nav-bar .van-icon {
    color: #fff;
  }

  .buttonBox {
    margin-top: 15px;
    overflow: hidden;
    height: 36px;

    .van-button {
      border: none;
      height: 35px;
      line-height: 30px;
      margin-left: 10px;
    }

    p {
      float: right;
      ;
    }
  }

  .van-button--plain.van-button--primary,
  .van-button--info {
    border: 1px solid #1989fa !important;
  }

  .images {
    margin-left: 20px;
  }

  .voucher img {
    width: 80px;
    height: 30px;
  }
</style>